<template>
  <div>
    <div class="pt-2 pb-2 pl-3 pr-3 border-2 border-white rounded-md divide-y divide-white">
        <div class="grid grid-cols-6 p-3">
            <div class="align-middle pt-3">
                <img alt="thu_tuc_don_gian" src="@/assets/default_main/3a.svg" />
            </div>
            <div class="col-span-5">
                <h2 class="font-bold-vmain color-vmain2 text-lg">
                    Thủ tục đơn giản
                </h2>
                <div>
                    Chỉ cần chứng minh nhân dân hoặc căn cước công dân
                </div>
            </div>
        </div>
        <div class="grid grid-cols-6 p-3">
            <div class="align-middle pt-3">
                <img alt="khong_cm_thu_nhap" src="@/assets/default_main/khong_chung_minh_thu_nhap.svg" />
            </div>
            <div class="col-span-5">
                <h2 class="font-bold-vmain color-vmain2 text-lg">
                    Không chứng minh thu nhập
                </h2>
                <div>
                    Duyệt vay dễ dàng, tỉ lệ giải ngân cao
                </div>
            </div>
        </div>
        <div class="grid grid-cols-6 p-3">
            <div class="align-middle pt-3">
                <img alt="rate_icon" src="@/assets/default_main/1a.svg" />
            </div>
            <div class="col-span-5">
                <h2 class="font-bold-vmain color-vmain2 text-lg">
                    Thông tin các khoản vay
                </h2>
                <div>
                    Lãi suất năm: <span class="font-bold"> 18 - 36 % </span>
                </div>
                <div>
                    Kỳ hạn khoản vay: <span class="font-bold"> 06 - 36 tháng </span>
                </div>
                <div>
                    Khoản vay: <span class="font-bold"> 10 - 80 triệu </span>
                </div>
                <!-- <div class="text-xs italic col-span-6 text-justify">
                    Ví dụ: Nếu bạn vay 10 triệu đồng với thời hạn 12 tháng, mức lãi suất thấp nhất của 12 tháng là 1,66%/tháng với dư nợ giảm dần (Lưu ý lãi suất này đã bao gồm tất cả chi phí). Khi tới thời hạn thanh toán bạn phải trả lãi 1.079.000đ. Như vậy, tổng số tiền bạn phải trả là 11.079.000đ (Chi phí là tổng chi phí bao gồm gốc và lãi). APR 19,92%
                </div> -->
            </div>

            
        </div>
        <!-- <div class="grid grid-cols-6 p-3">
            <div class="align-middle pt-2">
                <img src="@/assets/default_main/2a.svg" />
            </div>
            <div class="col-span-5">
                <div class="font-bold-vmain color-vmain2 text-lg">
                    Lãi suất ưu đãi từ 1.66%
                </div>
                <div>
                    Lãi suất hợp lý
                </div>
            </div>
        </div> -->
    </div>

    <!-- <div class="mt-4 pt-2 pb-2 pl-3 pr-3 border-2 border-white rounded-md divide-y divide-white">
        <div class="grid grid-cols-6 p-3">
            <div class="align-middle pt-3">
                <img src="@/assets/default_main/1a.svg" />
            </div>
            <div class="col-span-5">
               
                <div>
                    Với khoản vay tín dụng 60 triệu đồng, thời hạn vay 12 tháng, lãi suất 18%, hàng tháng bạn chỉ phải thanh toán 5.500.800 đồng.
                </div>
            </div>
        </div>

    </div> -->
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>